module.exports = __webpack_public_path__ + "static/media/curved-vector.3d701723.svg";